import { Box, Chip, Typography } from '@material-ui/core';
import { makeStyles, alpha } from '@material-ui/core/styles';
import { TypographyProps } from '@material-ui/core/Typography';

const useStyles = makeStyles(({ palette, spacing }) => ({
  blockedName: {
    textDecoration: 'line-through',
    opacity: 0.5,
  },
  blockedChip: {
    backgroundColor: alpha(palette.error.main, 1),
    color: palette.common.white,
    height: 16,
    fontSize: '0.625rem',
    fontWeight: 500,
    '& .MuiChip-label': {
      paddingLeft: spacing(0.75),
      paddingRight: spacing(0.75),
    },
  },
}));

interface BlockedContactNameProps {
  name: string;
  isBlocked: boolean;
  variant?: TypographyProps['variant'];
  noWrap?: boolean;
  /** Posição do chip em relação ao nome. Padrão: "after" */
  chipPosition?: 'before' | 'after';
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export function BlockedContactName({
  name,
  isBlocked,
  variant = 'body2',
  noWrap = true,
  chipPosition = 'after',
  className,
  style,
  children,
}: BlockedContactNameProps) {
  const classes = useStyles();

  const chip = isBlocked ? (
    <Chip label="Bloqueado" size="small" className={classes.blockedChip} />
  ) : null;

  return (
    <Box
      display="flex"
      alignItems="center"
      style={{ gap: 6, minWidth: 0, ...style }}
    >
      {chipPosition === 'before' && chip}
      <Typography
        variant={variant}
        noWrap={noWrap}
        className={isBlocked ? classes.blockedName : className}
        style={{ minWidth: 0 }}
      >
        {name}
      </Typography>
      {children}
      {chipPosition === 'after' && chip}
    </Box>
  );
}
